import {AbstractDiscoStandardMapper} from "../abstract-disco-standard.mapper";

export class FrDiscoSasSynthesisMapper extends AbstractDiscoStandardMapper {
}
